// Converts nested liquid sample data into flat path/value pairs for display
// e.g., { fan: { name: "John" } } => [{ path: "fan.name", value: "John" }]
export const flattenLiquidData = (obj, parent = "") => {
  return Object.entries(obj || {}).reduce((acc, [key, value]) => {
    const path = `${parent}${parent ? "." : ""}${key}`;
    if (value && typeof value === "object" && !Array.isArray(value) && !(value instanceof Date)) {
      acc.push(...flattenLiquidData(value, path));
    } else {
      acc.push({ path, value });
    }
    return acc;
  }, []);
};
